<mat-toolbar>ユーザー情報</mat-toolbar>

<mat-card class="user-info" *ngIf="auth.user | async as user">
  <!-- <mat-card-header>
    <mat-card-title class="user-info-title">ユーザー情報</mat-card-title>
  </mat-card-header> -->
  <mat-card-content>
    <p>{{user.id}}:{{user.displayName}}</p>
    <p>{{user.email}}</p>
    <button mat-raised-button (click)="logout()">ログアウト</button>
    <button id="moreButton" mat-icon-button (click)="rootPage('./personal-settings')">
      <mat-icon>settings</mat-icon>
    </button>
    <!-- <button mat-icon-button id="moreButton" [matMenuTriggerFor]="menu" aria-label="設定メニュー">
      <mat-icon>more_vert</mat-icon>
    </button> -->
  </mat-card-content>
</mat-card>
<mat-toolbar *ngIf="auth.user | async as user">メニュー</mat-toolbar>

<mat-card class="menu" *ngIf="auth.user | async as user">
  <mat-nav-list>
    <p class="mat-h2">勤怠管理</p>
    <a mat-list-item (click)="rootPage('./history')">打刻履歴</a>
    <a mat-list-item
       (click)="rootPage('./approve')"
       *ngIf="user.authority >= 1">
      <span class="menu-item-wrapper">
        <span>申請承認</span>
        <span class="menu-badge"
              [matBadge]="requestCount"
              matBadgeColor="accent"
              [matBadgeHidden]="requestCount <= 0"
              matBadgeOverlap="false"
              matBadgePosition="after"
              matBadgeDescription="申請承認メニューの未処理件数">
        </span>
      </span>
    </a>
    <a mat-list-item (click)="rootPage('./report')" *ngIf="user.manageAuthority >= 1 || user.authority >= 1">給与計算用レポート</a>
  </mat-nav-list>
  <mat-divider  *ngIf="user.manageAuthority >= 1"></mat-divider>
  <mat-nav-list *ngIf="user.manageAuthority >= 1">
    <p class="mat-h2">システム管理</p>
    <a mat-list-item (click)="rootPage('./user-manage')">ユーザー管理</a>
    <a mat-list-item (click)="rootPage('./team-manage')">組織管理</a>
    <a mat-list-item (click)="rootPage('./terminal-manage')" *ngIf="user.manageAuthority >= 99">端末管理</a>
  </mat-nav-list>
</mat-card>

<!-- <mat-menu #menu="matMenu">
  <button mat-menu-item>
    <mat-icon>settings</mat-icon>
    <span>個人設定</span>
  </button>
</mat-menu> -->


<p id="appVersion">AppVersion: {{appVersion}}</p>
